class MedicalHistoryConditions {
    public Hypertension?: boolean;
    public CardiacPulmonary?: boolean;
    public Endocrine?: boolean;
    public GastrointestinalLiver?: boolean;
    public BreastIncludingSurgery?: boolean;
    public GynecologicalIncludingSurgery?: boolean;
    public UrinaryTract?: boolean;
    public MusculoskeletalRheumatology?: boolean;
    public Hematological?: boolean;
    public ThromboembolicCoagulopathies?: boolean;
    public BloodTransfusion?: boolean;
    public Neurological?: boolean;
    public Other?: boolean;

    constructor(fields?: Partial<MedicalHistoryConditions>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.Hypertension = this.Hypertension || false;
        this.CardiacPulmonary = this.CardiacPulmonary || false;
        this.Endocrine = this.Endocrine || false;
        this.GastrointestinalLiver = this.GastrointestinalLiver || false;
        this.BreastIncludingSurgery = this.BreastIncludingSurgery || false;
        this.GynecologicalIncludingSurgery = this.GynecologicalIncludingSurgery || false;
        this.UrinaryTract = this.UrinaryTract || false;
        this.MusculoskeletalRheumatology = this.MusculoskeletalRheumatology || false;
        this.Hematological = this.Hematological || false;
        this.ThromboembolicCoagulopathies = this.ThromboembolicCoagulopathies || false;
        this.BloodTransfusion = this.BloodTransfusion || false;
        this.Neurological = this.Neurological || false;
        this.Other = this.Other || false;
    }
}

export { MedicalHistoryConditions };
